import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, orderBy, deleteDoc, doc } from 'firebase/firestore';
import SearchAndFilterBar from './SearchAndFilterBar';

const ContactList = ({ user, onEditContact }) => {
  const [allContacts, setAllContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
      type: { label: 'Type', value: 'all', options: ['Vendor', 'Agent'] }
  });

  useEffect(() => {
    if (!user) return;
    const q = query(collection(db, "contacts"), where("userId", "==", user.uid), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const contactsData = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setAllContacts(contactsData);
      setFilteredContacts(contactsData);
      setLoading(false);
    }, (err) => {
      console.error("Error fetching contacts:", err);
      setError("Failed to load contacts.");
      setLoading(false);
    });
    return () => unsubscribe();
  }, [user]);

  useEffect(() => {
    let results = allContacts;
    if (filters.type.value !== 'all') {
      results = results.filter(c => c.contactType === filters.type.value);
    }
    if (searchTerm) {
      results = results.filter(c => 
        c.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (c.contactPersonName && c.contactPersonName.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }
    setFilteredContacts(results);
  }, [searchTerm, filters, allContacts]);

  const handleDelete = async (contactId) => {
    if (window.confirm("Are you sure you want to delete this contact?")) {
      await deleteDoc(doc(db, "contacts", contactId));
    }
  };

  if (loading) return <p>Loading contacts...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div className="form-section">
      <div className="page-header">
        <h3>Contact List</h3>
        <SearchAndFilterBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} filters={filters} setFilters={setFilters} />
      </div>
      <div className="table-wrapper">
        <table className="product-list-table">
          <thead><tr><th>Type</th><th>Name/Company</th><th>Contact Person</th><th>Phone</th><th>Actions</th></tr></thead>
          <tbody>
            {filteredContacts.length === 0 ? (
              <tr><td colSpan="5" style={{textAlign: 'center'}}>No contacts match your criteria.</td></tr>
            ) : (
              filteredContacts.map(contact => (
                <tr key={contact.id}>
                  <td><span className={`contact-type-badge type-${contact.contactType}`}>{contact.contactType}</span></td>
                  <td>{contact.companyName}</td>
                  <td>{contact.contactPersonName || 'N/A'}</td>
                  <td>{contact.contactNumber || 'N/A'}</td>
                  <td className="cell-actions"><button className="edit-button" onClick={() => onEditContact(contact)}>Edit</button><button className="delete-button" onClick={() => handleDelete(contact.id)}>Delete</button></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactList;
